import { Vulnerabilities } from '@/sections/vulnerabilities';
import type { Hunt } from '@/types';

interface FindingsPaneProps {
  hunt: Hunt;
}

export function FindingsPane({ hunt }: FindingsPaneProps) {
  return (
    <div className="size-full">
      <Vulnerabilities
        name="huntDrawerVulnerabilities"
        parentFilters={{ huntKey: hunt.key, advancedFilters: {} }}
        hideTitle
        inDrawer
        hideBulkActions
        hideColumnSelector
        hideRowActions
        drawerFilters={['status', 'severity']}
        excludeColumns={['origins']}
      />
    </div>
  );
}
